var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { FilterData } from "path-shared/models/filter-data";
var ActuacioIncidenciaFilter = /** @class */ (function (_super) {
    __extends(ActuacioIncidenciaFilter, _super);
    function ActuacioIncidenciaFilter(sortField, sortDir) {
        var _this = _super.call(this, sortField, sortDir) || this;
        _this.somId = null;
        _this.labels['somId'] = _this.i18n('Id');
        return _this;
    }
    return ActuacioIncidenciaFilter;
}(FilterData));
export { ActuacioIncidenciaFilter };
